import { Checkmark } from 'react-checkmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import HomeFooter from './HomeFooter';

const MemberList = ({ member, dependents, calculateAge, onMemberSelect }) => (
    <ul className="mt-3 list-unstyled home-family-list">
        <li
            className="d-flex flex-row justify-content-between align-items-center border border-2 rounded px-2 py-2 home-family-list-item"
            style={{ width: '100%', cursor: 'pointer' }}
            onClick={() => onMemberSelect([member], 'member')}
        >
            <div>
                <p className="m-0 fw-bold">{member.FullName}</p>
                <span>
                    {member.Gender} | {calculateAge(member.DateofBirth)} years | <strong style={{ color: '#0E94C3' }}>( Self )</strong>
                </span>
            </div>
            <i className="bi bi-chevron-right fw-bolder"></i>
        </li>

        {dependents?.map((dependent) => (
            <li
                className="d-flex flex-row justify-content-between align-items-center border border-2 rounded p-2 mt-2"
                style={{ width: '100%', cursor: 'pointer' }}
                key={dependent.customerId}
                onClick={() => onMemberSelect(dependent, 'dependent')}
            >
                <div>
                    <p className="m-0 fw-bold">{dependent.name}</p>
                    <span>
                        {dependent.gender} | {calculateAge(dependent.dateofBirth)} years | <strong style={{ color: '#0E94C3' }}>( {dependent.relationship} )</strong>
                    </span>
                </div>
                <i className="bi bi-chevron-right fw-bolder"></i>
            </li>
        ))}
    </ul>
);

const MembershipCard = ({ frontCard, backCard, cardNumber, isFlipped, onToggle }) => (
    <div className="d-flex flex-column mt-5">
        <button
            type="button"
            aria-label="Show other side of membership card"
            style={{ width: '350px', height: '200px', margin: '10px', perspective: '1000px', border: 0, padding: 0, background: 'transparent' }}
            onClick={onToggle}
        >
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    textAlign: 'center',
                    transition: 'transform 0.6s',
                    transformStyle: 'preserve-3d',
                    transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                    borderRadius: '8px',
                }}
            >
                <div style={{ width: '100%', height: '100%', backfaceVisibility: 'hidden', borderRadius: '10px', overflow: 'hidden' }}>
                    {frontCard ? (
                        <>
                            <img src={frontCard.ConfigValue} alt="Front side" style={{ width: '100%', height: '100%' }} />
                            <p style={{ position: 'absolute', bottom: '15px', left: '40px', color: 'white', fontSize: '1.1rem' }}>{cardNumber}</p>
                        </>
                    ) : (
                        <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>
                    )}
                </div>
                <div
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        backfaceVisibility: 'hidden',
                        transform: 'rotateY(180deg)',
                        borderRadius: '10px',
                        overflow: 'hidden',
                    }}
                >
                    {backCard ? (
                        <img src={backCard.ConfigValue} alt="Back side" style={{ width: '100%', height: '100%' }} />
                    ) : (
                        <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>
                    )}
                </div>
            </div>
        </button>
    </div>
);

const FamilyDetailsScreen = ({
    backCard,
    calculateAge,
    dependents,
    formatDate,
    frontCard,
    goBackToLogin,
    isDataFetched,
    isFlipped,
    isValid,
    logo,
    memberDetails,
    onMemberSelect,
    onToggleCard,
    windowSize,
}) => {
    const member = memberDetails?.[0];

    return (
        <div className="d-flex flex-column justify-content-start align-items-center" style={{ minHeight: '100vh', width: '100vw', backgroundColor: '#0E94C3' }}>
            <div
                className="card d-flex flex-column justify-content-start align-items-center p-3 py-5"
                style={{ minWidth: windowSize.width < 576 ? '100vw' : windowSize.width <= 992 ? '75%' : '50%', minHeight: '100vh', position: 'relative' }}
            >
                <Checkmark size="medium" />
                <h5 className="text-black m-2 text-center fw-bold" style={{ fontSize: '18px' }}>OHOINDIA MEMBERSHIP VERIFICATION SUCCESS!</h5>

                {!isDataFetched ? (
                    <div className="spinner-border text-primary m-5" role="status"><span className="visually-hidden">Loading...</span></div>
                ) : member ? (
                    <>
                        <div className="d-flex flex-column p-2 my-3 border rounded" style={{ backgroundColor: '#e8ebe9', minWidth: '350px', maxWidth: '600px' }}>
                            <div className="d-flex flex-row justify-content-between" style={{ minWidth: '350px' }}>
                                <div className="d-flex flex-column align-items-center">
                                    <span>Status</span>
                                    <span className="d-flex flex-row align-items-center fw-semibold">
                                        <FontAwesomeIcon icon={faCircle} className="me-2" style={{ color: isValid ? '#04d928' : 'red', fontSize: '20px' }} />
                                        {isValid ? 'Active' : 'Inactive'}
                                    </span>
                                </div>
                                <div className="d-flex flex-column align-items-center">
                                    <span>{isValid ? 'Valid till' : 'Expired On'}</span>
                                    <span className="fw-semibold">{formatDate(member.EndDate)}</span>
                                </div>
                            </div>
                            <p className="mt-2 m-0"><strong>Address: </strong>{member.AddressLine1}</p>
                        </div>

                        <h5 className="fw-bold text-center home-family-title">SELECT FAMILY MEMBER</h5>
                        <MemberList member={member} dependents={dependents} calculateAge={calculateAge} onMemberSelect={onMemberSelect} />
                        <MembershipCard
                            frontCard={frontCard}
                            backCard={backCard}
                            cardNumber={member.OHOCardNumber}
                            isFlipped={isFlipped}
                            onToggle={onToggleCard}
                        />
                        <hr />
                        <button
                            type="button"
                            className="d-flex flex-row justify-content-center align-items-center bg-success text-white fw-semibold rounded border-0 home-family-close"
                            style={{ backgroundColor: '#0E94C3', width: '100%', maxWidth: '360px', minHeight: '40px', cursor: 'pointer' }}
                            onClick={goBackToLogin}
                        >
                            <i className="bi bi-x-lg me-2"></i><span>CLOSE</span>
                        </button>
                        <p className="text-center fw-semibold mt-3">Need any support ?</p>
                        <div className="d-flex flex-row mb-4 fw-semibold" style={{ fontSize: '15px' }}>
                            <a className="me-3" href="tel:+917671997108" style={{ textDecoration: 'none', color: '#0E94C3' }}><i className="bi bi-telephone"></i>+91 7671 997 108</a>
                            <a className="ms-3" href="tel:+917671997108" style={{ textDecoration: 'none', color: '#0E94C3' }}><i className="bi bi-telephone"></i>+91 7032 107 108</a>
                        </div>
                        <HomeFooter logo={logo} showCopyright={false} />
                    </>
                ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center text-center">
                        <p className="mt-5 fs-5">
                            We are unable to fetch Your details. Please contact at
                            <a className="text-primary ms-1" href="mailto:contact@ohoindialife.com">contact@ohoindialife.com</a>
                        </p>
                    </div>
                )}

                <div style={{ position: 'sticky', bottom: '30px', display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <button
                        type="button"
                        aria-label="Back to member verification"
                        style={{
                            color: '#fff', border: 'none', borderRadius: '50%',
                            width: windowSize.width < 576 ? '50px' : '60px',
                            height: windowSize.width < 576 ? '50px' : '60px',
                            backgroundColor: '#0E94C3', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '28px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', cursor: 'pointer', zIndex: 1000,
                        }}
                        onClick={goBackToLogin}
                    >
                        <i className="bi bi-house-door me-1"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FamilyDetailsScreen;
